import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { CompanyAuthenticationTabGzDataProvider } from '../dataProvider/CompanyAuthenticationTabGzDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class CompanyAuthenticationTabDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CompanyAuthenticationTabGzDataProvider);
  }
}
